import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { UIProvider } from './context/UIContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { EventProvider } from './context/EventContext.tsx';
import { NavigationProvider } from './context/NavigationContext.tsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UIProvider>
        <AuthProvider>
          <EventProvider>
            <NavigationProvider>
              <App />
            </NavigationProvider>
          </EventProvider>
        </AuthProvider>
      </UIProvider>
    </QueryClientProvider>
  </StrictMode>,
);
